<div id="main-window">
  <div>
    <span (click)="rotateImage()" class="material-icons-outlined ns-button--rotate">rotate_90_degrees_cw</span>
  </div>
  <image-cropper
    *ngIf="inputImage?.image || inputImage?.url"
    #cropper
    [imageBase64]="inputImage.image"
    [imageURL]="inputImage.url"
    [maintainAspectRatio]="false"
    aspectRatio="1 / 1"
    format="png"
    [autoCrop]="true"
    [canvasRotation]="canvasRotation"
    (loadImageFailed)="loadImageFailed()"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded($event)"
  ></image-cropper>
  <img
    id="outputImage"
    class="source-image"
    *ngIf="!inputImage?.image && outputImage.image"
    [src]="outputImage.image"
  />
  <!--<div class="ns-button--row">
    <button class="ns-button--action ns-button--action-discard" (click)="discard()">Discard</button>
    <button color="primary" class="ns-button--action ns-button--action-crop" (click)="cropImage()">Crop</button>
  </div>
--></div>
